import React from 'react'

import { LayoutFr } from './layout-fr'
import { LayoutEn } from './layout-en'
import { AvailableLocales } from '../../utils/locale'
import { IntlProvider } from 'react-intl'
import messagesEn from '../../intl/en.json'
import messagesFr from '../../intl/fr.json'

type RecursiveRecord = {
  [key: string]: string | RecursiveRecord
}

type LayoutProps = {
  children: React.ReactElement[]
  pageContext: { locale: AvailableLocales }
}

const Layout = ({ children, pageContext }: LayoutProps) => {
  const messages: Record<AvailableLocales, RecursiveRecord> = {
    en: messagesEn,
    fr: messagesFr,
  }

  const navigatorLocale = typeof window !== 'undefined' && window.navigator.language.startsWith('fr') ? 'fr' : 'en'
  const locale = pageContext?.locale || navigatorLocale

  return (
    <IntlProvider locale={locale} messages={messages[locale] as Record<string, string>}>
      {pageContext.locale === 'en' ? <LayoutEn>{children}</LayoutEn> : <LayoutFr>{children}</LayoutFr>}
    </IntlProvider>
  )
}

export default Layout
